module.exports = __webpack_public_path__ + "img/bikini_bottom_sign.c3f7abee.jpg";